//uat
// export const baseUrl =   "https://uathelp.tataplay.com";

//prod
export const baseUrl =   "https://help.tataplay.com";
